import Input from '@jetbrains/ring-ui/components/input/input'

import useSearchInput from '../../../../hooks/useSearchInput'
import type {FilterOptions} from '../../../../types'

type Props = {
  className?: string
  revision: string
  comment: string
  path: string
  onChangeFilter: (filter: FilterOptions) => unknown
}

function ChangesContentFilter({className, revision, comment, path, onChangeFilter}: Props) {
  const revisionSearchInput = useSearchInput(revision, data => onChangeFilter({revision: data}))
  const commentSearchInput = useSearchInput(comment, data => onChangeFilter({comment: data}))
  const pathSearchInput = useSearchInput(path, data => onChangeFilter({path: data}))

  return (
    <>
      <Input
        data-test-changes-content-filter-message
        inputRef={commentSearchInput.inputRef}
        type="search"
        placeholder="Filter by comment..."
        className={className}
        autoComplete={comment !== commentSearchInput.value ? 'off' : 'on'}
        value={commentSearchInput.value}
        onChange={commentSearchInput.onChange}
        onClear={commentSearchInput.onClear}
      />
      <Input
        data-test-changes-content-filter-path
        inputRef={pathSearchInput.inputRef}
        type="search"
        placeholder="Path..."
        className={className}
        autoComplete={path !== pathSearchInput.value ? 'off' : 'on'}
        value={pathSearchInput.value}
        onChange={pathSearchInput.onChange}
        onClear={pathSearchInput.onClear}
      />
      <Input
        data-test-changes-content-filter-revision
        inputRef={revisionSearchInput.inputRef}
        type="search"
        placeholder="Revision..."
        className={className}
        autoComplete={revision !== revisionSearchInput.value ? 'off' : 'on'}
        value={revisionSearchInput.value}
        onChange={revisionSearchInput.onChange}
        onClear={revisionSearchInput.onClear}
      />
    </>
  )
}

export default ChangesContentFilter
